// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React from 'react';
import { TextFieldProps } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { DateTime } from 'luxon';
import LuxonUtils from '@date-io/luxon';

import { translate } from '@portal/services/i18n';
import { InputBaseComponentProps } from '@mui/material';

type AdvancedDateTimePickerProps = {
  value?: string | null;
  label?: string;
  variant?: TextFieldProps['variant'];
  onChange: (val) => void;
  time?: boolean;
  hint?: string;
  onlyDate?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  maxDate?: DateTime | null;
  minDate?: DateTime | null;
  inputProps?: InputBaseComponentProps;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  error?: boolean;
  shouldDisableDate?: (date: DateTime) => boolean;
};

const AdvancedDateTimePicker = ({
  value,
  label,
  variant = 'outlined',
  onChange,
  time,
  hint,
  onlyDate,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  inputProps,
  placeholder,
  disabled,
  style,
  error,
  shouldDisableDate,
}: AdvancedDateTimePickerProps) => {
  const { palette } = useTheme();

  const useStyles = makeStyles({
    root: {
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.primary.main,
      },
    },
  });

  const classes = useStyles();

  const inputPropsStyle = {
    fontFamily: 'Inter, sans-serif',
    ...inputProps?.style,
  };

  const handleDateChange = (date: DateTime | null) => {
    if (date && shouldDisableDate && shouldDisableDate(date)) {
      return;
    }
    onChange(date);
  };
  return (
    <div className="advanced-date-time-picker">
      <MuiPickersUtilsProvider utils={LuxonUtils} locale="pt-BR">
        {time && !onlyDate ? (
          <KeyboardTimePicker
            variant="inline"
            label={label}
            value={value}
            style={style}
            onChange={handleDateChange}
            format={translate('APPLICATION.DEFAULT_DATE_FORMAT.LUXON_HOURS')}
            inputVariant={variant}
            autoOk
            ampm={false}
            disabled={disabled}
            className={classes.root}
            inputProps={{
              ...inputProps,
              style: inputPropsStyle,
            }}
            fullWidth
          />
        ) : null}

        {!time && !onlyDate && (
          <KeyboardDateTimePicker
            variant="inline"
            ampm={false}
            label={label}
            value={value}
            style={style}
            onChange={handleDateChange}
            disablePast
            format={translate(
              'APPLICATION.DEFAULT_DATE_FORMAT.LUXON_DATE_HOURS'
            )}
            inputVariant={variant}
            autoOk
            invalidDateMessage={translate(
              'APPLICATION.ERRORS.DATE.INVALID_DATE'
            )}
            maxDateMessage={translate(
              'APPLICATION.ERRORS.DATE.INVALID_MAX_DATE'
            )}
            minDateMessage={translate(
              'APPLICATION.ERRORS.DATE.INVALID_MIN_DATE'
            )}
            disabled={disabled}
            error={error}
            shouldDisableDate={shouldDisableDate}
            className={classes.root}
            inputProps={{
              ...inputProps,
              style: inputPropsStyle,
            }}
            fullWidth
          />
        )}

        {!time && onlyDate ? (
          <KeyboardDatePicker
            variant="inline"
            label={label}
            value={value ? DateTime.fromISO(value).toJSDate() : null}
            onChange={handleDateChange}
            disableFuture={disableFuture}
            disablePast={disablePast}
            format={translate('APPLICATION.DEFAULT_DATE_FORMAT.LUXON')}
            inputVariant={variant}
            maxDate={maxDate}
            minDate={minDate}
            inputProps={{
              ...inputProps,
              style: inputPropsStyle,
            }}
            placeholder={placeholder}
            style={style}
            error={error}
            shouldDisableDate={shouldDisableDate}
            invalidDateMessage={translate(
              'APPLICATION.ERRORS.DATE.INVALID_DATE'
            )}
            maxDateMessage={translate(
              'APPLICATION.ERRORS.DATE.INVALID_MAX_DATE'
            )}
            minDateMessage={translate(
              'APPLICATION.ERRORS.DATE.INVALID_MIN_DATE'
            )}
            disabled={disabled}
            className={classes.root}
            fullWidth
          />
        ) : null}
        {hint}
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default AdvancedDateTimePicker;
